import domains from './domains';
import projects from './domainProjects';
import users from './domainUsers';
import domainGroups from './domainGroups';

export default {
  namespaced: true,
  modules: {
    domains,
    projects,
    users,
    domainGroups
  }
};
